import Vue from 'vue'
import Router from 'vue-router'

// Auth Pages
import Login from './pages/auth/Login.vue'
import UpdatePassword from './pages/auth/UpdatePassword.vue'
import Register from './pages/auth/Register.vue'

// Info Pages
import Messages from './pages/info/Messages.vue'
import Faq from './pages/info/Faq.vue'
import About from './pages/info/About.vue'
import Contact from './pages/info/Contact.vue'

// App Pages
import Dashboard from './pages/app/Dashboard.vue'
import Profile from './pages/app/Profile.vue'
import Calendar from './pages/app/Calendar.vue'
import Preorder from './pages/app/Preorder.vue'
import Products from './pages/app/Products.vue'
import Product from './pages/app/Product.vue'
import Checkout from './pages/app/Checkout.vue'
import Ward from './pages/app/Ward.vue'
import Unconfirmed from './pages/app/Unconfirmed.vue'
import Categories from './pages/app/Categories.vue'
import Freeissueorder from './pages/app/Freeissueorder.vue'
import Feedback from './pages/app/Feedback.vue'
import Printer from './pages/app/Printer.vue'
import Allbeds from './pages/app/Allbeds.vue'
import Beds from './pages/app/Beds.vue'
import PatientRequests from './pages/app/PatientRequests.vue'
Vue.use(Router)

const router = new Router({
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'dashboard',
      component: Dashboard
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile
    },
    {
      path: '/printer',
      name: 'printer',
      component: Printer
    },
    {
      path: '/preorder/:ward/:bed',
      name: 'calendar',
      component: Calendar
    },
    {
      path: '/freeissueorder',
      name: 'freeissueorder',
      component: Freeissueorder
    },,
    {
      path: '/Feedback',
      name: 'Feedback',
      component: Feedback
    },
    {
      path: '/preorder/:ward/:bed/:date',
      name: 'preorder',
      component: Preorder
    },
    {
      path: '/preorder/:ward/:bed/:date/:period/categories',
      name: 'categories',
      component: Categories
    },
    {
      path: '/preorder/:ward/:bed/:date/:period/:category/products',
      name: 'products',
      component: Products
    },
    {
      path: '/preorder/:ward/:bed/:date/:period/:category/products/:productId',
      name: 'product',
      component: Product
    },
    {
      path: '/checkout',
      name: 'checkout',
      component: Checkout
    },
    {
      path: '/unconfirmed',
      name: 'unconfirmed',
      component: Unconfirmed
    },
    {
      path: '/ward',
      name: 'ward',
      component: Ward
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/updatePassword',
      name: 'updatePassword',
      component: UpdatePassword
    },
    {
      path: '/register',
      name: 'register',
      component: Register
    },
    {
      path: '/messages',
      name: 'messages',
      component: Messages
    },
    {
      path: '/faq',
      name: 'faq',
      component: Faq
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact
    },
    {
      path: '/allbeds',
      name: 'allbeds',
      component: Allbeds
    },
    {
      path: '/unconfirmed/:wardId/beds',
      name: 'beds',
      component: Beds
    },
    {
      path: '/patientrequests',
      name: 'patientrequests',
      component: PatientRequests
    }
  ]
})

router.afterEach(function () {
  window.scrollTo(0, 0)
  document.body.scrollTop = 0
  var content = document.querySelector('.app-content')
  if (content) content.scrollTop = 0
})

export default router
